var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("About")]),_c('div',[_vm._v(" See the Project on "),_c('a',{attrs:{"href":"https://github.com/hemandee/k8s-practice"}},[_vm._v("GitHub")])])])}
var staticRenderFns = []

export { render, staticRenderFns }